import { create } from '@bufbuild/protobuf';

import {
  IExternalVideo,
  IGraphicSize,
  ILinkPreviewModel,
  IUserMentionData,
} from '@gem/models/commonModel';

import {
  ExternalUnknownVideoSchema,
  ExternalVideo,
  ExternalVideoSchema,
  ExternalYouTubeVideoSchema,
  GraphicSize,
  GraphicSizeSchema,
  LinkPreview,
  LinkPreviewSchema,
} from 'APP/wsApi/wsAppApi/types/common/common_model_pb';
import { UserMention } from 'APP/wsApi/wsAppApi/types/message/message_model_pb';

export function mapUserMention(data: UserMention): IUserMentionData {
  return {
    userId: data.userId.toString(),
    nickname: data.nickname,
  };
}

export function mapToIGraphicSize(data?: GraphicSize): IGraphicSize {
  return {
    height: data?.height || 0,
    width: data?.width || 0,
  };
}

export function mapToGraphicSize(graphicSize: IGraphicSize): GraphicSize {
  return create(GraphicSizeSchema, {
    height: graphicSize.height,
    width: graphicSize.width,
  });
}

export function mapILinkPreviewModel(linkPreview?: LinkPreview): ILinkPreviewModel {
  return {
    link: linkPreview?.link || '',
    title: linkPreview?.title || '',
    description: linkPreview?.description || '',
    domain: linkPreview?.domain || '',
    image:
      linkPreview?.image && linkPreview.image.graphicSize
        ? {
            url: linkPreview.image.url,
            graphicSize: linkPreview.image.graphicSize,
          }
        : undefined,
    video: linkPreview?.video
      ? {
          type: linkPreview.video.type.case === 'youTube' ? 'youtube' : 'unknown',
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore TODO: need to fix out Video types
          videoId:
            linkPreview.video.type.case === 'youTube'
              ? linkPreview.video.type.value.videoId.toString()
              : undefined,
        }
      : undefined,
  };
}

export function mapToLinkPreview(preview: ILinkPreviewModel): LinkPreview {
  return create(LinkPreviewSchema, {
    link: preview.link,
    title: preview.title,
    description: preview.description,
    image: preview.image,
    domain: preview.domain,
    video: preview.video ? mapToExternalVideo(preview.video) : undefined,
  });
}

function mapToExternalVideo(video: IExternalVideo): ExternalVideo {
  if (video.type === 'youtube') {
    return create(ExternalVideoSchema, {
      type: {
        case: 'youTube',
        value: create(ExternalYouTubeVideoSchema, {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          videoId: video.videoId,
        }),
      },
    });
  } else {
    return create(ExternalVideoSchema, {
      type: {
        case: 'unknown',
        value: create(ExternalUnknownVideoSchema, {}),
      },
    });
  }
}
